<template>
  <div class="page-container home-inspector representation-container">
    <section class="representation-content">
      <article class="text-section table-section" v-if="isShowingRate && getApplicantType === 'NEW'">
        <div class="text-justify orep-mobile" style="font-size: 1rem; line-height: 1.6;">

          <h2 class="orep-heading">🛡️ 90 Days of Protection for Just $30</h2>
          <ul class="list-reset orep-list">
            <li><strong>The Perfect First Policy for New Inspectors</strong></li>
            <li>Congratulations on taking your first step toward protecting your inspection business the smart way-with <strong>OREP</strong>.</li>
          </ul>

          <h3 class="orep-subheading">🔒 What You Just Applied For</h3>
          <ul class="list-reset orep-list">
            <li>✔️ $500,000 / $500,000 Coverage Limits</li>
            <li>✔️ Includes Errors & Omissions + General Liability</li>
            <li>✔️ Full Access to OREP Member Benefits</li>
            <li>✔️ Available exclusively to new inspectors in their first year, with no prior coverage</li>
          </ul>

          <h3 class="orep-subheading">📌 Requirements: For New Inspectors Only!</h3>
          <ul class="list-reset orep-list">
            <li>● In Your First Year of Inspector Business</li>
            <li>● No Prior Insurance</li>
          </ul>

          <p class="orep-paragraph">Get Quality Coverage for the first 90 days of your business for only $30.</p>

          <!-- Original Button Logic -->
          <div class="orep-button-group">

            <button
                @click="navigateToNext('ipfs-payment-30')"
                class="orep-btn"
            >CLICK HERE TO MAKE PAYMENT</button>

          </div>

          <h3 class="orep-subheading">⚠️ Important: Don't Let Coverage Lapse</h3>
          <p>This is a <strong>Claims-Made Policy</strong>, which means your protection ends with the policy unless you transition to an <strong>annual plan before the 90 days are up</strong>.</p>
          <p><strong>No annual policy = no coverage</strong>, even for inspections you performed during your 90-day term. Don't risk it.</p>
          <p class="orep-paragraph">We'll remind you before your 90 days are up-but why wait? Ask us now about upgrading to full annual coverage and lock in your peace of mind.</p>

          <div class="orep-button-group">
            <button
                @click="navigateToNext('ipfs-payment-30')"
                class="orep-btn"
            >CLICK HERE TO MAKE PAYMENT</button>
          </div>

          <p class="orep-paragraph" style="margin-top: 24px;"><strong>Welcome to OREP.</strong> You're not just covered-you're supported. Let's build your business together.</p>
        </div>
      </article>
      <article v-else-if="isShowingRate">
        <div v-if="isShowingRate" class="row justify-content-md-center pt-4">
          <div class="col-md-8 mb-3 mt-3">
            <span class="text-center proposal-title" for="">
              <strong>Premium Proposal for: </strong> <span class=" blue-color">{{quote.fullLegalNameOfApplicant}}</span>
            </span>
          </div>
          <div class="col-md-8 mb-3">
            <span class="col-md-4 text-center proposal-title pl-0 pr-0" for="">
              <strong>Limits of Coverage: </strong>
            <span class=" blue-color">
            {{coverages[quote.coverage].limitOfCoverage}}
            </span>
            </span>
          </div>
          <div class="col-md-8">
            <span class="col-md-3 text-center proposal-title pl-0" for="">
              <strong>Deductible: </strong>
            </span>
            <strong style="font-size: 23px;"  v-if="deductibleAmount" >$1,500</strong>
            <strong style="font-size: 23px;" v-if="!deductibleAmount" >$2,500</strong>
          </div>

          <div class="col-md-8 mb-3 pt-5">
            <div class="radio orep-radio-wrapper solo-checkbox">
              <label>
                <input
                    type="checkbox"
                    name="cyberTechnologyCoverage"
                    class="orep-radio"
                    v-model="quote.cyberTechnologyCoverage"
                    @change="totalAfterCyberTechnologyCoverage(coverages)"
                >
                <span class="radio-span solo-checkbox-span cyber-technology-coverage-title">Add
                  <a href="https://orep.org/100K-cyber-coverage-hi" target="_blank">
                  Cyber and Technology Security Coverage</a> for just $125</span>
              </label>
            </div>
          </div>

        </div>
        <div v-if="isShowingRate" class="row pt-5 mb-5">
          <h2 class="text-center font-weight-bold mx-auto">
            This Quote includes E&O and General Liability in ONE Policy:
          </h2>        
        </div>
        <div v-if="isShowingRate" class="row mr-0 ml-0">
          <div class="col-md-7">
            <div class="text-center pull-left ml-0">
              <p v-if="quote.cyberCoverage" class="mr-0 representation-price-font-active" >{{ coverages[quote.coverage].downCyberTotal }}</p>
              <p v-else class="mr-0 representation-price-font-active">{{ coverages[quote.coverage].downTotal }}</p><span style="font-size:19px;position:relative;top:-12px;" class="blue-color">Down Payment</span>
              <br><span style="top:-22px;position:relative;font-size: 11px;" class="blue-color">Finance Your Policy - Finance Charge Applies</span>
            </div>
            <button v-if="(this.quote.customer.state === 'AR' || this.quote.customer.state === 'CA' || this.quote.customer.state === 'FL'
            || this.quote.customer.state === 'ND' || this.quote.customer.state === 'WV' || this.quote.customer.state === 'WY'
            || this.quote.customer.state === 'KS' || this.quote.customer.state === 'NJ' || this.quote.customer.state === 'NE'
            || this.quote.customer.state === 'WA' || this.quote.customer.state === 'CT' || this.quote.customer.state === 'MA'
            || this.quote.customer.state === 'OH' || this.quote.customer.state === 'NY') && state.submittedSlDisclosure === false" class="pull-right text-center pay-now"
                    @click="formSubmit()">PAY NOW</button>

<!--            <a v-else-if="getApplicantType === 'RISKPRO'" v-bind:href="'https://orep.org/financeunited150-riskpro/index.php?name='+quote.nameOfPrincipalHomeInspector+'&ia_name='+quote.fullLegalNameOfApplicant+'&address='+encodeURIComponent(quote.customer.address)+'&city='+quote.customer.city+'&state_code='+quote.customer.state+'&zip='+quote.customer.zipCode+'&phone='+quote.customer.phone+'&email='+quote.customer.email+'&date='+formattedCurrentDate()+'&premium='+total(coverages).toFixed(2)"-->
<!--               target="_blank"-->
<!--               class="pull-right text-center pay-now_2">PAY NOW</a>-->

            <a v-else-if="quote.cyberTechnologyCoverage" v-bind:href="coverages[quote.coverage].paymentLinkWithCyberTechnology"
               target="_blank"
               class="pull-right text-center pay-now_2">PAY NOW</a>
            <a v-else v-bind:href="coverages[quote.coverage].paymentLinkWithOutCyberTechnology"
               target="_blank"
               class="pull-right text-center pay-now_2">PAY NOW</a>
          </div>
          <div class="col-md-5 quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
              class="orep-select quote-include"
              name="state"            
              v-validate="'required'"            
            >
              Quote Includes
            </button>
          </div>
        </div>
        <div v-if="isShowingRate" class="row quote-action quote-include-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">E&O/GL PREMIUM:</span>
                <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberPremium }}</span>
                <span v-else >{{ coverages[quote.coverage].premium }}</span>                
              </li>              
              <li>
                <span class="title"> {{ this.quote.customer.state }} SL TAX:</span><span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberSurplusLineTax }}</span>
                <span v-else >{{ coverages[quote.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quote.customer.state }} SL STAMPING FEE:</span> <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberStampingFee }}</span>
                <span v-else >{{ coverages[quote.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP MEMBER FEE: </span>
                <span>{{ coverages[quote.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">ADDITIONAL STATE FEE:</span>
                <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberExtraFee }} </span>
                <span v-else >{{ coverages[quote.coverage].extraFee }} </span>
              </li>

              <li v-if="quote.cyberTechnologyCoverage">
                <span class="title">Cyber:</span>
                <span>{{ coverages[quote.coverage].premiumCyberTechnologyCoverage }}</span>
              </li>

              <li class="total">
              <span class="title">TOTAL DUE:</span>
                <h5 class="font-weight-bold m-0" v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberTotal }}</h5>
                <h5 class="font-weight-bold m-0" v-else>{{ coverages[quote.coverage].total }}</h5>
              </li>              
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Personal Injury Coverage</span>
              </li>              
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} General Liability Coverage(Per Claim)</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Professional Liability -  Each Claim</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Professional Liability - Aggregate Limit </span>
              </li>
              <li>
                <span class="title_1">$25,000 Disciplinary Proceedings</span>
              </li>
              <li>
                <span class="title_1">$5,000 Loss of Earnings</span>
              </li>              
            </ul>
          </div>
        </div>
        <div v-if="isShowingRate" class="row mr-0 ml-0 text-center" style="border:1px solid #ccc">
          <div class="col-md-7">
            <div class="text-center money-text pull-left representation-price-font">
              <p class="representation-price-font-disable" v-if="quote.cyberCoverage">{{ coverages[quote.coverage].cyberTotal }}</p>
              <p class="representation-price-font-disable" v-else>{{ coverages[quote.coverage].total }}</p>
              <p class="blue-color mb-0">Total - Pay in Full</p>
            </div>
            <button v-if="(this.quote.customer.state === 'AR' || this.quote.customer.state === 'CA' || this.quote.customer.state === 'FL'
            || this.quote.customer.state === 'ND' || this.quote.customer.state === 'WV' || this.quote.customer.state === 'WY'
            || this.quote.customer.state === 'KS' || this.quote.customer.state === 'NJ' || this.quote.customer.state === 'NE'
            || this.quote.customer.state === 'WA' || this.quote.customer.state === 'CT' || this.quote.customer.state === 'MA'
            || this.quote.customer.state === 'OH' || this.quote.customer.state === 'NY') && state.submittedSlDisclosure === false"
                    class="pull-right pay-now_3"
                    @click="formSubmit()">PAY NOW</button>
            <button v-else
                    class="pull-right pay-now_3"
                    @click="navigateToNext('home-inspector-payment')">PAY NOW</button>
          </div>
          <div class="col-md-5 quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
              class="orep-select quote-include_1"
              name="state"            
              v-validate="'required'"            
            >
              Quote Includes
            </button>
          </div>
        </div>
        <div v-if="isShowingRate" class="row quote-action quote-include_1-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">E&O/GL PREMIUM:</span>
                <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberPremium }}</span>
                <span v-else >{{ coverages[quote.coverage].premium }}</span>                
              </li>              
              <li>
                <span class="title"> {{ this.quote.customer.state }} SL TAX:</span><span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberSurplusLineTax }}</span>
                <span v-else >{{ coverages[quote.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quote.customer.state }} SL STAMPING FEE:</span> <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberStampingFee }}</span>
                <span v-else >{{ coverages[quote.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP MEMBER FEE: </span>
                <span>{{ coverages[quote.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">ADDITIONAL STATE FEE:</span>
                <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberExtraFee }} </span>
                <span v-else >{{ coverages[quote.coverage].extraFee }} </span>
              </li>

              <li v-if="quote.cyberTechnologyCoverage">
                <span class="title">Cyber:</span>
                <span>{{ coverages[quote.coverage].premiumCyberTechnologyCoverage }}</span>
              </li>

              <li class="total">
              <span class="title">TOTAL DUE:</span>
                <h5 class="font-weight-bold m-0" v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberTotal }}</h5>
                <h5 class="font-weight-bold m-0" v-else>{{ coverages[quote.coverage].total }}</h5>
              </li>              
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Personal Injury Coverage</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} General Liability Coverage(Per Claim)</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Professional Liability -  Each Claim</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Professional Liability - Aggregate Limit </span>
              </li>
              <li>
                <span class="title_1">$25,000 Disciplinary Proceedings</span>
              </li>
              <li>
                <span class="title_1">$5,000 Loss of Earnings</span>
              </li>
            </ul>
          </div>
        </div>
      </article>
      <article v-else >
        <label for="" class="text-justify" style="font-size: 25px">
          Thank you for submitting your application. Based on one or more answers, your application will need to be reviewed by an underwriter before we can present you with a premium proposal. Someone from {{ getApplicantType }} will reach out to you via email or phone within two business days. Thank you for shopping {{ getApplicantType }}!
        </label>
      </article>
      <article class="text-section table-section mt-5">
        <label for="" class="text-center font-weight-bold">
          Most Programs Do Not <em><strong>Specialize</strong></em> in Home Inspector Insurance and Defense. <span style="color:#A81508">We Do</span>. It Matters.
        </label> 
        <div class="table-responsive">
          <table class="table-bordered mt-4 ">
            <thead>
              <th  v-if="getApplicantType === 'SPMGA'" width="60%" class="text-center font-weight-bold">Why Choose Southern Preferred?</th>
              <th  v-else-if="getApplicantType === 'RWS'" width="60%" class="text-center font-weight-bold">Why Choose RWS Insurance?</th>
              <th  v-else-if="getApplicantType === 'RISKPRO'" width="60%" class="text-center font-weight-bold">Why Choose RISKPRO Insurance?</th>
              <th  v-else width="60%" class="text-center font-weight-bold">Why Choose OREP?</th>
              <th v-if="getApplicantType === 'SPMGA'" width="20%" class="text-center font-weight-bold">Included with SPMGA</th>
              <th v-else-if="getApplicantType === 'RWS'"width="20%" class="text-center font-weight-bold">Included with RWS</th>
              <th v-else-if="getApplicantType === 'RISKPRO'"width="20%" class="text-center font-weight-bold">Included with RISKPRO</th>
              <th v-else width="20%" class="text-center font-weight-bold">Included with OREP</th>
              <th width="20%" class="text-center font-weight-bold">The Other Guys</th>
            </thead>
            <tbody>
              <tr>
                <td>
                  <label for="" class="red-text mb">
                    Attorney Led Pre-Claims Support
                  </label>
                  <label for="" class="table-text">
                    Trial attorney Geoff Binney, with over a decade of experience defending inspectors, provides pre-claims support and decisive response letters to shut down frivolous claims. Don’t leave your financial future in the hands of a claims adjuster who doesn’t know your business.
                  </label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div>              
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">
                    Business Building Benefits
                  </label>

                  <label  v-if="getApplicantType === 'SPMGA'" for="" class="table-text">SPMGA Members enjoy Free
                    Training Webinars on marketing, risk management, and liability, as well as access to
                    InspectorAdvisor.com, where they can get their questions answered by an experienced expert. And much
                    more!</label>
                  <label  v-else-if="getApplicantType === 'RWS'" for="" class="table-text">RWS Members enjoy Free
                    Training Webinars on marketing, risk management, and liability, as well as access to
                    InspectorAdvisor.com, where they can get their questions answered by an experienced expert. And much
                    more!</label>
                  <label  v-else-if="getApplicantType === 'RISKPRO'" for="" class="table-text">RISKPRO Members enjoy Free Training Webinars on marketing, risk management, and liability, as well as access to InspectorAdvisor.com, where they can get their questions answered by an experienced expert. And much more!</label>
                  <label  v-else for="" class="table-text"> {{ getApplicantType }} Members enjoy Free Training Webinars on marketing, risk management, and liability, as well as access to InspectorAdvisor.com, where they can get their questions answered by an experienced expert. And much more!</label>

                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div> 
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">
                    Over 20 Years Defending Home Inspectors
                  </label>
                  <label for="" class="table-text">
                    We've been insuring and defending home inspectors for decades. Were' not just a passing fad. 
                  </label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div> 
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">
                    Guaranteed Delivery of Working RE Home Inspector
                  </label>
                  <label for="" class="table-text">
                    Stay informed and “in-the-know” with a subscription to the most widely read trade publication in the home inspection profession.
                  </label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div> 
                </td>
                <td class="text-center">                 
                </td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">
                    Coverage Designed Specifically for Home Inspectors                    
                  </label>
                  <label for="" class="table-text">
                    Your coverage needs are NOT generic. {{ getApplicantType }}'s policy is designed specifically for home inspectors and includes coverage for Mold, Termite/WDO, Infrared, Pool/Spa, Drones, Carbon Monoxide, and much more!
                  </label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div> 
                </td>
                <td class="text-center">
                  <label class="text-center"  for="">
                    Sometimes
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">
                    Policy Includes E&O and General Liability Coverage in a Single Policy
                  </label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div> 
                </td>
                <td class="text-center">
                  <label class="text-center"  for="">
                    Rarely
                  </label>
                </td>
              </tr>
              <tr>
                <td>
                  <label for="" class="red-text">
                    Mold Coverage Included in Base Policy at no charge
                  </label>
                </td>
                <td>
                  <div>
                    <img src="../../../public/assets/images/shield1.png">
                  </div> 
                </td>
                <td class="text-center">
                  <label class="text-center"  for="">
                    Almost Never
                  </label>
                </td>
              </tr>                                        
            </tbody>
          </table>
        </div>

      </article>
      <article class="text-section table-section mt-5 mb-5">
        <label class="pt-4 text-center font-weight-bold blue-color w-100" for="">
          What Our Customers Say About Us:
        </label>
        <div class="row mt-4">
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">     
            </div>
            <p class="review-wrapper">
              I have been an {{ getApplicantType }} customer for over five years, and these guys are fantastic. They have always gone ‘above and beyond' with their service and are quick to respond to any concerns or
              needs I may have. I highly recommend them for your Insurance needs.<strong> Danny B.</strong>
            </p>
          </div>
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">     
            </div>
            <p class="review-wrapper">
              Getting a quote was easy and {{ getApplicantType }} was able to provide comprehensive coverage for my inspection business, when other companies could not.<br><strong> Bob P.</strong>
            </p>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">     
            </div>
            <p class="review-wrapper">
              I needed to get an insurance policy in place to renew my Home Inspection license. {{ getApplicantType }} completed the paperwork quickly and efficiently. Thank you.<br><strong> B. Doyle </strong>
            </p>
          </div>
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">     
            </div>
            <p class="review-wrapper">
              Very easy to work with. I found them to have the most comprehensive coverage for the cost of coverage. They can cover WDI, Drone, Home Inspections and other services all at the same low
              price. I started with them when I first started inspecting, one of the few to offer new inspectors insurance. Highly recommend.<br><strong> Jon S.</strong>
            </p>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">     
            </div>
            <p class="review-wrapper">
              I've been with {{ getApplicantType }} since I began and have no issues. If I call, I get to talk to a real live person! That's important to me!<br> <strong>Jim K. </strong>
            </p>
          </div>
          <div class="col-md-6">
            <div class="star-wrapper">
              <img src="../../../public/assets/images/five_blue_stars.png">     
            </div>
            <p v-if="getApplicantType !== 'RISKPRO'" class="review-wrapper">
              Competitive pricing, superior coverage. Although I do not envision needing heir claim support services, I sleep well knowing {{ getApplicantType }} has Sugarland Home Inspections, LLC well-covered.<br><strong>Kevin L.</strong>
            </p>
          </div>
        </div>
      </article>
      <article v-if="isShowingRate && getApplicantType === 'NEW'">
        <div class="row pt-5 mb-5 input-section footer-wrapper ml-0 mr-0">
          <h2 class="text-center mx-auto">
            <strong>Questions?</strong> Chat, <a href = "mailto:inspectors@OREP.org">Email</a>, or Call Now (888) 347-5273.
          </h2>
        </div>
      </article>

      <article v-else-if="isShowingRate">
        <div v-if="isShowingRate" class="row pt-5 mb-5  input-section text-center">
          <h5 class="text-center mx-auto">
            <span class="blue-color2 pr-1"><span></span>{{ quote.fullLegalNameOfApplicant }} <span></span></span><strong> Enjoy Coverage Beginning: </strong><span class="blue-color2">{{ formattedCurrentDate() }}</span>
          </h5>
        </div>
        <div v-if="isShowingRate" class="row mr-0 ml-0">
          <div class="col-md-7">
            <div class="text-center money-text pull-left">
              <p v-if="quote.cyberCoverage" class="mr-0 representation-price-font-active" >{{ coverages[quote.coverage].downCyberTotal }}</p>
              <p v-else class="mr-0 representation-price-font-active">{{ coverages[quote.coverage].downTotal }}</p><span style="font-size:18px;top:-9px;position:relative;" class="blue-color">Down Payment</span>
              <br><span style="top:-22px;position:relative;font-size: 11px;" class="blue-color">Finance Your Policy- Finance Charge Applies</span>
            </div>
            <button v-if="(this.quote.customer.state === 'AR' || this.quote.customer.state === 'CA' || this.quote.customer.state === 'FL'
            || this.quote.customer.state === 'ND' || this.quote.customer.state === 'WV' || this.quote.customer.state === 'WY'
            || this.quote.customer.state === 'KS' || this.quote.customer.state === 'NJ' || this.quote.customer.state === 'NE'
            || this.quote.customer.state === 'WA' || this.quote.customer.state === 'CT' || this.quote.customer.state === 'MA'
            || this.quote.customer.state === 'OH' || this.quote.customer.state === 'NY') && state.submittedSlDisclosure === false" class="pull-right pay-now"
                    @click="formSubmit()">PAY NOW</button>
            <a v-else-if="quote.cyberTechnologyCoverage" v-bind:href="coverages[quote.coverage].paymentLinkWithCyberTechnology"
               target="_blank"
               class="pull-right text-center pay-now_2">PAY NOW</a>
            <a v-else v-bind:href="coverages[quote.coverage].paymentLinkWithOutCyberTechnology"
               target="_blank"
               class="pull-right text-center pay-now_2">PAY NOW</a>
          </div>
          <div class="col-md-5 quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
              class="orep-select quote-include_2"
              name="state"            
              v-validate="'required'"            
            >
              Quote Includes
            </button>
          </div>
        </div> 
        <div v-if="isShowingRate" class="row quote-action quote-include_2-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">E&O/GL PREMIUM:</span>
                <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberPremium }}</span>
                <span v-else >{{ coverages[quote.coverage].premium }}</span>                
              </li>              
              <li>
                <span class="title"> {{ this.quote.customer.state }} SL TAX:</span><span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberSurplusLineTax }}</span>
                <span v-else >{{ coverages[quote.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quote.customer.state }} SL STAMPING FEE:</span> <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberStampingFee }}</span>
                <span v-else >{{ coverages[quote.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP MEMBER FEE: </span>
                <span>{{ coverages[quote.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">ADDITIONAL STATE FEE:</span>
                <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberExtraFee }} </span>
                <span v-else >{{ coverages[quote.coverage].extraFee }} </span>
              </li>

              <li v-if="quote.cyberTechnologyCoverage">
                <span class="title">Cyber:</span>
                <span>{{ coverages[quote.coverage].premiumCyberTechnologyCoverage }}</span>
              </li>

              <li class="total">
                <span class="title">TOTAL DUE:</span>
                <h5 class="font-weight-bold m-0" v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberTotal }}</h5>
                <h5 class="font-weight-bold m-0" v-else>{{ coverages[quote.coverage].total }}</h5>
              </li>              
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Personal Injury Coverage</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} General Liability Coverage(Per Claim)</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Professional Liability -  Each Claim</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Professional Liability - Aggregate Limit </span>
              </li>
              <li>
                <span class="title_1">$25,000 Disciplinary Proceedings</span>
              </li>
              <li>
                <span class="title_1">$5,000 Loss of Earnings</span>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="isShowingRate" class="row mr-0 ml-0">
          <div class="col-md-7">
            <div class="text-center money-text pull-left">
              <p class="representation-price-font-disable" v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberTotal }}</p>
              <p class="representation-price-font-disable" v-else>{{ coverages[quote.coverage].total }}</p>
              <span style="font-size:17px;top:-10px;">Total - Pay in Full</span>
            </div>
            <button v-if="(this.quote.customer.state === 'AR' || this.quote.customer.state === 'CA' || this.quote.customer.state === 'FL'
            || this.quote.customer.state === 'ND' || this.quote.customer.state === 'WV' || this.quote.customer.state === 'WY'
            || this.quote.customer.state === 'KS' || this.quote.customer.state === 'NJ' || this.quote.customer.state === 'NE'
            || this.quote.customer.state === 'WA' || this.quote.customer.state === 'CT' || this.quote.customer.state === 'MA'
            || this.quote.customer.state === 'OH' || this.quote.customer.state === 'NY') && state.submittedSlDisclosure === false"
                    class="pull-right pay-now_3"
                    @click="formSubmit()">PAY NOW</button>
            <button v-else
                    class="pull-right pay-now_3"
                    @click="navigateToNext('home-inspector-payment')">PAY NOW</button>

          </div>
          <div class="col-md-5 quote-includes-btn-wrapper flex align-items-center justify-content-md-center">
            <button
              class="orep-select quote-include_3"
              name="state"            
              v-validate="'required'"            
            >
              Quote Includes
            </button>
          </div>
        </div>
        <div v-if="isShowingRate" class="row quote-action quote-include_3-action-wrapper input-section mr-0 ml-0">
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title">E&O/GL PREMIUM:</span>
                <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberPremium }}</span>
                <span v-else >{{ coverages[quote.coverage].premium }}</span>                
              </li>              
              <li>
                <span class="title"> {{ this.quote.customer.state }} SL TAX:</span><span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberSurplusLineTax }}</span>
                <span v-else >{{ coverages[quote.coverage].surplusLineTax }}</span>
              </li>
              <li>
                <span class="title"> {{ this.quote.customer.state }} SL STAMPING FEE:</span> <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberStampingFee }}</span>
                <span v-else >{{ coverages[quote.coverage].stampingFee }}</span>
              </li>
              <li>
                <span class="title">OREP MEMBER FEE: </span>
                <span>{{ coverages[quote.coverage].orepFee }}</span>
              </li>
              <li>
                <span class="title">ADDITIONAL STATE FEE:</span>
                <span v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberExtraFee }} </span>
                <span v-else >{{ coverages[quote.coverage].extraFee }} </span>
              </li>

              <li v-if="quote.cyberTechnologyCoverage">
                <span class="title">Cyber:</span>
                <span>{{ coverages[quote.coverage].premiumCyberTechnologyCoverage }}</span>
              </li>

              <li class="total">
              <span class="title">TOTAL DUE:</span>
                <h5 class="font-weight-bold m-0" v-if="quote.cyberCoverage" >{{ coverages[quote.coverage].cyberTotal }}</h5>
                <h5 class="font-weight-bold m-0" v-else>{{ coverages[quote.coverage].total }}</h5>
              </li>              
            </ul>
          </div>
          <div class="col-md-6">
            <ul>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Personal Injury Coverage</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} General Liability Coverage(Per Claim)</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Professional Liability -  Each Claim</span>
              </li>
              <li>
                <span class="title_1">{{ coverages[quote.coverage].orepClaim }} Professional Liability - Aggregate Limit </span>
              </li>
              <li>
                <span class="title_1">$25,000 Disciplinary Proceedings</span>
              </li>
              <li>
                <span class="title_1">$5,000 Loss of Earnings</span>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="getApplicantType === 'SPMGA'" class="row pt-5 mb-5 input-section footer-wrapper ml-0 mr-0">
          <h2 class="text-center mx-auto">
            <strong>Questions?</strong> Chat, <a href = "mailto:christy@orep.org ">Email</a>, or Call Now (281) 674-7146.
          </h2>        
        </div>
        <div v-else-if="getApplicantType === 'RWS'" class="row pt-5 mb-5 input-section footer-wrapper ml-0 mr-0">
          <h2 class="text-center mx-auto">
            <strong>Questions?</strong> Chat, <a href = "mailto:info@rwsinsurance.com">Email</a>, or Call Now 866-530-0531.
          </h2>
        </div>
        <div v-else-if="getApplicantType === 'RISKPRO'" class="row pt-5 mb-5 input-section footer-wrapper ml-0 mr-0">
          <h2 class="text-center mx-auto">
            <strong>Questions?</strong> Chat, <a href = "mailto:RISKPRO@liabilityinsuranceapps.com">Email</a>, or Call Now (972) 235-3030.
          </h2>
        </div>
        <div v-else class="row pt-5 mb-5 input-section footer-wrapper ml-0 mr-0">
          <h2 class="text-center mx-auto">
            <strong>Questions?</strong> Chat, <a href = "mailto:inspectors@OREP.org">Email</a>, or Call Now (888) 347-5273.
          </h2>
        </div>
      </article>
    </section>        
  </div>
</template>
<script>
import $ from "jquery";
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";
import moment from "moment";

  export default {
    name: 'home-inspector-representation',
    computed: {
      quote() {
        return this.$store.state.homeInspector.quote;
      },
      coverages() {
        return this.$store.state.homeInspector.coverages;
      },
      state() {
        return this.$store.state.homeInspector;
      },

      isShowingRate() {
        return !(this.$store.getters['homeInspector/totalRevenueOfInspectionsInThisYear'] > 150000 ||
          this.$store.getters['homeInspector/totalRevenueOfInspectionsInNextYear'] > 150000 ||
          this.quote.licensedInWorkingStates === 'no' ||
          this.quote.haveYourExperiencedBankruptcyInLast7Years === 'true' ||
          this.quote.complianceInspections === 'true' ||
          this.quote.involvedInAuctionOfPersonalProperty === 'true' ||
          this.quote.performInspectionsOnOwnProperty === 'true' ||
          this.quote.providesRepairWorkOnInspectedProperty === 'true' ||
          this.quote.doYouUseIndependentContractors === 'true' ||
          Number(this.quote.homeInspectorsFullTime) + Number(this.quote.homeInspectorsPartTime) > 2 ||
          this.quote.knowledgeOfActEoPotentialClaimFuture === 'true' ||
          this.quote.hasBeenSubjectToEoClaimPast === 'true' ||
          this.quote.criticizedCensoredSuspendedRevoked === 'true' ||
          this.quote.insuranceDeniedCancelledNonrenewedInsurance === 'true' ||
          this.quote.applicantExclusiveToAnyCompany === 'true' ||
          this.quote.isThereAMethodToAuthenticatePhotoDatetime === 'false' ||
          this.quote.customer.state === 'OR' ||
          this.quote.customer.state === 'HI' ||
          this.quote.customer.state === 'AK'
          || this.quote.customer.state === 'KY'
        );
      },
      isShowingUnderneathText() {
      return this.quote.singleClientProvidesMt25PercentRevenue === 'true' ||
        this.quote.applicantExclusiveToAnyCompany === 'true' ||
        this.quote.providesOtherServices === 'true' ||
        this.quote.applicantOrAssociateProvidesOtherServices === 'true' ||
        this.quote.enteredLimitedLiabilityContract === 'true' ||
        this.quote.applicantOrAssociateHasAnyOtherProfessionalLicense === 'true' ||
        this.quote.isPreInspectionAgreementAlwaysSigned === 'false' ||
        this.quote.applicantTakesDigitalPhotosOfInspections === 'false' ||
        this.quote.isThereAMethodToAuthenticatePhotoDatetime === 'false' ||
        this.quote.applicantTakesContinuingTrainingYearly === 'false' ||
        this.quote.averageOfMoreThan3InspectionsPerDayPerInspector === 'true';
      },
      deductibleAmount() {

        return ((this.quote.homeInspectingExperience === '3-to-7' ||
          this.quote.homeInspectingExperience === '3-to-7' ) &&
          this.quote.knowledgeOfActEoPotentialClaimFuture === 'false' &&
          this.quote.hasBeenSubjectToEoClaimPast === 'false' &&
          this.quote.criticizedCensoredSuspendedRevoked === 'false' &&
          this.quote.insuranceDeniedCancelledNonrenewedInsurance === 'false' &&
          this.quote.preInspectionAgreementHasLimitationOfLiabilityClause === 'true' &&
          this.$store.getters['homeInspector/totalRevenueOfInspectionsInThisYear'] <= 150000 &&
          Number(this.quote.homeInspectorsFullTime) + Number(this.quote.homeInspectorsPartTime) < 3);
      },
      getApplicantType() {
        var route = this.$route.path;
        var first = route.substring(0, route.lastIndexOf("/") + 1);
        if (first === '/portal/home-inspector-ibd/' || first === '/portal/home-inspector-IBD/'|| this.quote.customer.partnerName === 'IBD'){
          return 'IBD';
        }else if (first === '/portal/home-inspector-rws/' || first === '/portal/home-inspector-rws/'|| this.quote.customer.partnerName === 'RWS'){
          return 'RWS';
        }else if (first === '/portal/home-inspector-spmga/' || first === '/portal/home-inspector-spmga/'|| this.quote.customer.partnerName === 'SPMGA'){
          return 'SPMGA';
        }
        else if (first === '/portal/home-inspector-NEW/' || first === '/portal/home-inspector-new/'|| this.quote.customer.partnerName === 'NEW'){
          return 'NEW';
        }
        else if (first === '/riskpro/home-inspector/' || first === '/RISKPRO/home-inspector/' || this.quote.customer.partnerName === 'RISKPRO'){
          return 'RISKPRO';
        }
        else {
          return 'OREP';
        }
      },
    },
    methods: {
      
      navigateToNext(routeName) {
        this.$router.push({
          name: routeName
        });
      },
      slDisclosure(){
        return true;
      },
    slDisclosure_test(){
        if (this.quote.customer.state === 'AR' || this.quote.customer.state === 'CA' || this.quote.customer.state === 'FL'
            || this.quote.customer.state === 'ND' || this.quote.customer.state === 'WV' || this.quote.customer.state === 'WY'
            || this.quote.customer.state === 'KS' || this.quote.customer.state === 'NJ' || this.quote.customer.state === 'NE'
            || this.quote.customer.state === 'WA' || this.quote.customer.state === 'CT' || this.quote.customer.state === 'MA'
            || this.quote.customer.state === 'OH' || this.quote.customer.state === 'NY'){
          return true;
        }
        else {
          return false;
        }
      },
      formSubmit() {
        this.loading = true;
        this.quote.status = STATUS.Submitted;
        this.quote.customer.appStatus = APP_STATUS.Completed;
        this.$store.dispatch('homeInspector/createFormalQuote');
      },
      isSlDisclosureSubmitted() {
        return false;
      },
      dollarSlicing(sclicingValue) {
        return sclicingValue.slice(1);
      },
      formattedCurrentDate() {
        return moment.utc(this.quote.applicantPrincipleEsignatureDatetime).format('MM/DD/YYYY');
      },
      getEffectiveDate() {
        return moment.utc(this.state.quote.effectiveDate).format('MM/DD/YYYY');
      },

      totalAfterCyberTechnologyCoverage(coverages) {
        if (this.quote.cyberTechnologyCoverage) {
          coverages[this.quote.coverage].total = coverages[this.quote.coverage].totalWithCyberTechnologyCoverage
          coverages[this.quote.coverage].downTotal = coverages[this.quote.coverage].downTotalWithCyberTechnologyCoverage
        }
        else{
          coverages[this.quote.coverage].total = coverages[this.quote.coverage].totalWithoutCyberTechnologyCoverage
          coverages[this.quote.coverage].downTotal = coverages[this.quote.coverage].downTotalWithoutCyberTechnologyCoverage
        }
      },
      
      total(coverages) {
        if (this.quote.cyberCoverage){
          if (this.quote.cyberTechnologyCoverage){
            return parseFloat((coverages[this.quote.coverage].cyberPremium).slice(1).replace(',','')) + parseFloat((coverages[this.quote.coverage].cyberSurplusLineTax).slice(1)) + parseFloat((coverages[this.quote.coverage].cyberStampingFee).slice(1)) + parseFloat((coverages[this.quote.coverage].cyberExtraFee).slice(1)) + parseFloat((coverages[this.quote.coverage].premiumCyberTechnologyCoverage).slice(1));
          }
          return parseFloat((coverages[this.quote.coverage].cyberPremium).slice(1).replace(',','')) + parseFloat((coverages[this.quote.coverage].cyberSurplusLineTax).slice(1)) + parseFloat((coverages[this.quote.coverage].cyberStampingFee).slice(1)) + parseFloat((coverages[this.quote.coverage].cyberExtraFee).slice(1));
        }
        else {
          if (this.quote.cyberTechnologyCoverage){
            return parseFloat((coverages[this.quote.coverage].premium).slice(1).replace(',','')) + parseFloat((coverages[this.quote.coverage].surplusLineTax).slice(1)) + parseFloat((coverages[this.quote.coverage].stampingFee).slice(1)) + parseFloat((coverages[this.quote.coverage].extraFee).slice(1)) + parseFloat((coverages[this.quote.coverage].premiumCyberTechnologyCoverage).slice(1));
          }
          return parseFloat((coverages[this.quote.coverage].premium).slice(1).replace(',','')) + parseFloat((coverages[this.quote.coverage].surplusLineTax).slice(1)) + parseFloat((coverages[this.quote.coverage].stampingFee).slice(1)) + parseFloat((coverages[this.quote.coverage].extraFee).slice(1));
        }
      },
      down_total(coverages) {
        if (this.quote.cyberCoverage){
          return coverages[this.quote.coverage].downCyberTotal;
        }
        else {
          return coverages[this.quote.coverage].downTotal;
        }
      },
    },
    mounted: function() {
      $(".orep-select.quote-include").click(function(){
        if($(this).hasClass("active")){
          $(this).removeClass("active");
          $(".quote-include-action-wrapper").css("padding-top", "0px"); 
          $(".quote-include-action-wrapper").css("height", "0px");            
          $(".quote-include-action-wrapper").css("opacity", "0");   
        }else{
          $(this).addClass("active");
          $(".quote-include-action-wrapper").css("padding-top", "40px"); 
          $(".quote-include-action-wrapper").css("height", "330px");            
          $(".quote-include-action-wrapper").css("opacity", "1");   
        }          
      }),
      $(".orep-select.quote-include_1").click(function(){
        if($(this).hasClass("active")){
          $(this).removeClass("active");
          $(".quote-include_1-action-wrapper").css("padding-top", "0px"); 
          $(".quote-include_1-action-wrapper").css("height", "0px");            
          $(".quote-include_1-action-wrapper").css("opacity", "0");   
        }else{
          $(this).addClass("active");
          $(".quote-include_1-action-wrapper").css("padding-top", "40px"); 
          $(".quote-include_1-action-wrapper").css("height", "330px");            
          $(".quote-include_1-action-wrapper").css("opacity", "1");   
        }          
      }),
      $(".orep-select.quote-include_2").click(function(){
        console.log(33333);        
        if($(this).hasClass("active")){
          $(this).removeClass("active");
          $(".quote-include_2-action-wrapper").css("padding-top", "0px");
          $(".quote-include_2-action-wrapper").css("height", "0px");
          $(".quote-include_2-action-wrapper").css("opacity", "0");
        }else{
          $(this).addClass("active");
          $(".quote-include_2-action-wrapper").css("padding-top", "40px");
          $(".quote-include_2-action-wrapper").css("height", "330px");
          $(".quote-include_2-action-wrapper").css("opacity", "1");
        }
      }),
      $(".orep-select.quote-include_3").click(function(){
        if($(this).hasClass("active")){
          $(this).removeClass("active");
          $(".quote-include_3-action-wrapper").css("padding-top", "0px");
          $(".quote-include_3-action-wrapper").css("height", "0px");
          $(".quote-include_3-action-wrapper").css("opacity", "0");
        }else{
          $(this).addClass("active");
          $(".quote-include_3-action-wrapper").css("padding-top", "40px");
          $(".quote-include_3-action-wrapper").css("height", "330px");
          $(".quote-include_3-action-wrapper").css("opacity", "1");
        }
      }),
      $('html, body').animate({
        scrollTop: $('.representation-container').offset().top
      }, 500);
    },  
  }  
</script>

<style scoped>
.coverage-link {
  text-decoration: none;
  font-weight: bold;
  font-family: Roboto, sans-serif;
  color: #046085;
}

.coverage-link:hover {
  text-decoration: underline;
}
</style>